import React from 'react'
import cpp from "../assets/cpp.png";
import html from "../assets/html.png";
import css from "../assets/css.png";
import javascript from "../assets/javascript.png";
import node from "../assets/node.png";
import ts from "../assets/ts.png";
import mysql from "../assets/mysql.png";
import mongo from "../assets/mongo.jpeg";
import spring from "../assets/spring.png";


const Skills = () => {

  const techs= [
    {
        id:1,
        src:cpp,
        title: 'C++',
        style: 'shadow-orange-500'
    },
    {
        id:2,
        src:html,
        title: 'HTML',
        style: 'shadow-orange-500'
    },
    {
        id:3,
        src:css,
        title: 'CSS',
        style: 'shadow-blue-500'
    },
    {
        id:4,
        src:javascript,
        title: 'Javascript',
        style: 'shadow-yellow-500'
    },
    {
        id:5,
        src:node,
        title: 'NodeJs',
        style: 'shadow-green-500'
    },
    {
        id:6,
        src:ts,
        title: 'Typescript',
        style: 'shadow-blue-500'
    },
    {
        id:7,
        src:mysql,
        title: 'MySQL',
        style: 'shadow-sky-500'
    },
    {
        id:8,
        src:mongo,
        title: 'MongoDB',
        style: 'shadow-green-500'
    },
    {
        id:9,
        src:spring,
        title: 'Springboot',
        style: 'shadow-green-500'
    },
  ]  
  return <div name="skills" className='bg-gradient-to-b from-black to-gray-900 w-full h-screen'>
    <div className='max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full text-white'>
        <div>
            <p className='text-4xl font-bold border-b-4 border-gray-500 inline'>Skills</p>
            <p className='text-xl py-3'>The tech stack I have worked with</p>
        </div>

        <div className='w-full grid grid-cols-2 sm:grid-cols-3 gap-8 text-center py-8 px-12 sm:px-0'>
        {
            techs.map(({id,src,title,style}) =>
            (
                <div key={id} className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg ${style}`}>
                <img src={src} alt="" className='w-20 mx-auto' />
                <p className='mt-4'>{title}</p>
                </div>
            ))
        }
            
        </div>

    </div>
  </div>;

  
}

export default Skills